<template>
  <div class="content">
    <div class="main">
      <h3>{{ $route.query.subjectName }}</h3>
      <el-collapse accordion>
        <el-collapse-item
          v-for="(collapse, i) in subjectData"
          :key="i"
          :disabled="collapse.attachs.length <= 0"
        >
          <template slot="title">
            <icon-svg class="icon" icon-class="wenjianjia" />{{
              collapse.chapter_title
            }}
          </template>
          <div class="itemContent">
            <div
              v-for="(text, h) in collapse.attachs"
              :key="h"
              class="contentText"
            >
              <span :title="text.title">{{ text.title }}</span>
              <span>{{ size(text.size) }}</span>
              <el-button
                v-if="text.can_down !== 0"
                @click="getInfo(collapse.chapter_id, text.id)"
              >
                下载
              </el-button>
              <el-button v-else class="cur">
                <icon-svg icon-class="suoding" />
              </el-button>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { getSubjectData, getSubjectInfo } from '@/network/request'
export default {
  name: 'Kechengziliao',
  components: {},
  props: {},
  data() {
    return {
      subjectData: [], // 课程资料列表
      subjectInfo: {}, // 课程信息
    }
  },
  computed: {
    // 换算单位
    size() {
      return (i) => {
        const kb = i / 1024
        if (kb < 1024) {
          return `${Math.round(kb)} KB`
        } else {
          return `${Math.round(kb / 1024)} MB`
        }
      }
    },
  },
  watch: {},
  created() {
    this.getSubjectData()
  },
  mounted() {},
  methods: {
    async getSubjectData() {
      const res = await getSubjectData(this.$route.query.course_id)
      console.log(res.data.result)
      this.subjectData = res.data.result
    },
    async getInfo(chapterId, attachId) {
      const res = await getSubjectInfo({
        chapter_id: chapterId,
        attach_id: attachId,
      })
      this.subjectInfo = res.data.result
      location.href = res.data.result.object.down_url // 下载文件
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  padding-top: 32px;
}
.icon {
  margin-right: 10px;
}
.el-collapse {
  border-top: 0;
}

::v-deep(.el-collapse-item) {
  .el-collapse-item__header {
    font-size: 16px;
    color: #141414;
    font-weight: 500;
    padding: 32px 0;
  }
  &.is-disabled {
    .el-collapse-item__arrow {
      display: none;
    }
  }
}
.main {
  width: 960px;
  margin: 0 auto;
  background-color: #fff;
  padding: 38px 35px;
  border-radius: 12px;
  margin-bottom: 40px;
  min-height: 800px;
  h3 {
    font-size: 20px;
    letter-spacing: -1px;
    color: #141414;
    margin-bottom: 15px;
  }
  p {
    font-size: 13px;
    letter-spacing: -1px;
    color: #999999;
    margin-bottom: 30px;
  }
}
.itemContent {
  background-color: #f8f8f9;
  padding: 25px;
  margin-top: 10px;
  border-radius: 12px;
  .contentText {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px;
    font-size: 16px;
    color: #666666;
    span:first-child {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    span:nth-child(2) {
      width: 80px;
      text-align: center;
      margin-right: 60px;
      margin-left: 50px;
    }
    .el-button {
      background: none;
      padding: 0;
      width: 60px;
      height: 28px;
      line-height: 28px;
      color: #666;
      font-weight: 400;
    }
  }
  .contentText:last-child {
    margin-bottom: 0;
  }
}
.cur {
  cursor: no-drop;
  /* 清除默认边框 */
  border: 0;
}
</style>
